export function getSectionId(el) {
    const section = el.closest('.shopify-section');
    if (!section) return null;

    return section.id?.replace('shopify-section-', '') || null;
}
